import {ServerService} from "../services/server.service";
import {Injectable} from "@angular/core";
import {DataService} from "../services/data.service";


@Injectable({
   providedIn: 'root'
})
export class OrdineFactory {

   constructor(private serverSrv: ServerService,
               private dataSrv: DataService) {
   }
}

export enum OrderStatusShopify{
   ORDER_NUOVO = 0,
   ORDER_IN_LAVORAZIONE = 10,
   ORDER_IN_SPEDIZIONE = 20,
   ORDER_COMPLETATO = 100,
   ORDER_ANNULLATO = -100,
}

export enum STATO_ORDINE{
   BOZZA = "bozza",
   COMPLETO = "completo",
   CONFERMATO = "confermato",
   NASCOSTO = "nascosto",
   CANCELLATO = "cancellato",
}

export enum STATO_TRASFERIMENTO{
   PREPARAZIONE = "preparazione",
   SPEDITO = "spedito",
   CONSEGNATO = "consegnato",
}

export enum TIPO_ORDINE{
   CLIENTE = "cli",
   CLIENTE_RESO = "cli_r",
   FORNITORE = "for",
   FORNITORE_RESO = "for_r",
   TRASFERIMENTO = "tras",
   AMMANCO = "amm",
   ESUBERO = "esu",
   WEB = "wb"
}

export enum TIPO_ORDINE_API{
   VENDITA = "vendite",
   TRASFERIMENTO = "trasferimenti",
   RETTIFICA = "rettifiche"
}

export enum DIREZIONE_TRASFERIMENTO{
   INGRESSO = 'in',
   USCITA = 'out',
}

export class OrdineData {
   id?: number;
   pvendita?: number;
   p_vendita_name?: number;
   pvendita_dst?: number;
   p_vendita_dst_name?: number;
   cliente?: any;
   fornitore?: number | any;
   codice_ordine?: string;
   data_creazione?:string;
   data_spedizione?:string;
   metodo_pagamento?:string;
   altro_metodo?:string;
   total_gross?:number;
   total?:number;
   total_tax?:number;
   imponibile?:number;
   iva?:number;
   sconto?: number;
   saldo?: number;
   note?: string;
   tot_venduti?:number;
   tot_convalidati?:number;
   causale?: string;
   stato?: string;
   stato_trasferimento?: string;
   tipo?: string;
   is_convalida_chiusa?: boolean;
   display_id?: string;
   ordine_rif?: number;
   canale_vendita?: number;
   convalide_cnt?: number;
   documento?: string;
   sconti_ordini?:any;
   spedizioni_ordini?:any;
   pagamenti?:any;
   tot_pagamenti?:number;
   rimanente_pag?:number;
   ddt?:string;
   perc_pagamento?:number;
   iva_non_applicabile?:boolean;
   prodotti_imponibile?:number;
   prodotti_imponibile_lordo?:number;
   ext_url?:string;
   ext_id?:string;
}

export class Ordine {

   data:OrdineData = {}

   constructor(data:OrdineData) {
      // assegno al mio oggetto data (è un json)
      if(!data) data = {}
      Object.assign(this.data, data)
   }

   public static MetodoPagamentoOrdineFornitore = [
      {value:'bonif', display:"Bonifico bancario"},
      {value:'b_ant', display:"Bonifico bancario anticipato"},
      {value:'contr', display:"Contrassegno (titoli al corriere)"},
      {value:'riba', display:"RIBA"},
      {value:'rid', display:"RID"},
      {value:'tit', display:"Titoli (anticipati)"},
      {value:'altro', display:"Altro"},
   ]

   public static MetodoPagamento = [
      {value:'cont', display:"Contanti"},
      {value:'cart', display:"Carta"},
      {value:'altro', display:"Altro"},
   ]

   public static TipoSconto = [
      {value:'sco_flat', display:"Sconto in Valore Assoluto"},
      {value:'sco_perc', display:"Sconto in Valore Percentuale"},
      {value:'buo', display:"Buono Acquisto"},
   ]

   public static HeaderFilterStatoData = [{
      text: "Completo",
      value: STATO_ORDINE.COMPLETO
   }, {
      text: "Bozza",
      value: STATO_ORDINE.BOZZA
   }, {
      text: "Cancellato",
      value: STATO_ORDINE.CANCELLATO
   }
      //    {
      //    text: "Confermato",
      //    value: STATO_ORDINE.CONFERMATO
      // },

   ];

   public static HeaderFilterStatoTrasferimentoData = [{
      text: "Preparazione",
      value: STATO_TRASFERIMENTO.PREPARAZIONE
   }, {
      text: "Spedito",
      value: STATO_TRASFERIMENTO.SPEDITO
   }, {
      text: "Consegnato",
      value: STATO_TRASFERIMENTO.CONSEGNATO
   }
   ];

   public static CanaliVenditaChoices = [{
      text: "POS",
      value: 1
   }, {
      text: "SHOPIFY",
      value: 2
   }
   ];

   public static TipoVenditaChoices = [{
      text: "CLIENTE",
      value: "cli"
   }, {
      text: "WEB",
      value: "wb"
   }
   ];

   public static StatoOrdine = {
      'NASCOSTO':'nascosto',
      'BOZZA':'bozza',
      'COMPLETO':'completo',
      'CONFERMATO':'confermato'
   }

   public static TipoScontoChoices = {
      'FLAT':'sco_flat',
      'PERCENTUALE':'sco_perc',
      'BUONO':'buo'
   }

   public static HeaderFilterWebStatoData = [{
      text: "Confermato",
      value: OrderStatusShopify.ORDER_NUOVO
   },
      //    {
      //    text: "In Lavorazione",
      //    value: OrderStatusShopify.ORDER_IN_LAVORAZIONE
      // }, {
      //    text: "In Spedizione",
      //    value: OrderStatusShopify.ORDER_IN_SPEDIZIONE
      // }, {
      //    text: "Completato",
      //    value: OrderStatusShopify.ORDER_COMPLETATO
      // },
      {
         text: "Annullato",
         value: OrderStatusShopify.ORDER_ANNULLATO
      }

   ];

   public static toOrderStatusClasses(status: OrderStatusShopify){
      switch (status) {
         case OrderStatusShopify.ORDER_NUOVO:
            return "bg-yellow-400 text-white"
         case OrderStatusShopify.ORDER_IN_LAVORAZIONE:
            return "bg-yellow-200"
         case OrderStatusShopify.ORDER_IN_SPEDIZIONE:
            return "bg-cyan-200"
         case OrderStatusShopify.ORDER_COMPLETATO:
            return "bg-green-600 text-white"
         case OrderStatusShopify.ORDER_ANNULLATO:
            return "bg-slate-900 text-white"
         default:
            return "bg-slate-900 text-white"
      }
   }
}
